import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  standalone: true,
  selector: 'tlc-navigation-separator',
  styleUrls: ['../navigation.vars.less', './navigation-separator.component.less'],
  template: `
    @if (minimized()) {
      <div class="separator"></div>
    } @else {
      {{ label() }}
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.minimized]': 'minimized()',
    '[class.nested]': 'nested()',
  },
})
export class TellentNavigationSeparatorComponent {
  public label = input.required<string>();
  public minimized = input.required<boolean>();
  public nested = input<boolean>(false);
}
